import info from 'virtual:build-info';
import { BetaSchemaForm } from '@ant-design/pro-components';
import dayjs from 'dayjs';
import {
  clearAll,
  clearDB,
  exportLogs,
  isDebug,
  logService,
} from '@/scripts/utils/devUtils';
import { useChatContext } from '@/contexts/chat/context';
import { userApis } from '@/configs/apis/user';
import { devStorage } from '@/configs/storages/browser';
import styles from './index.module.scss';
import CompanyIcon from './images/company.svg?react';

const MyCompany = () => {
  const { encryptMsg, setEncryptMsg } = useChatContext();
  const timerId = useRef<any>();
  return (
    <>
      <div className={styles.myCompany}>
        <CompanyIcon
          onMouseDown={() => {
            timerId.current = setTimeout(() => {
              const id_dev = devStorage.getItem('is_debug');
              devStorage.setItem('is_debug', !id_dev);
              location.reload();
            }, 2000);
          }}
          onMouseUp={() => {
            clearTimeout(timerId.current);
          }}
        ></CompanyIcon>
        <div className={styles.name}>My Company</div>
      </div>
      {isDebug && (
        <div className={styles.info}>
          <Popover
            mouseLeaveDelay={0.5}
            content={
              <ul style={{ maxWidth: 300 }}>
                <li>Date: {info.buildTime}</li>
                <li>Version: {info.version}</li>
                <li>Mode: {info.buildMode}</li>
                <li>{info.environment.REQUEST_BASE_URL}</li>
                <li>{info.environment.REQUEST_BASE_URL_WS}</li>
                <li style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <Button size="small" onClick={clearDB}>
                    Clear DB
                  </Button>
                  <Button size="small" onClick={clearAll}>
                    Clear All
                  </Button>
                </li>
                <li style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  <Popover
                    content={
                      <BetaSchemaForm
                        layout="horizontal"
                        columns={[
                          {
                            title: 'Batches',
                            dataIndex: 'batches',
                            initialValue: logService.batch,
                          },
                          {
                            title: 'Key',
                            dataIndex: 'key',
                          },
                          {
                            title: 'Keyword',
                            dataIndex: 'keyword',
                          },
                          {
                            title: 'Date Range',
                            dataIndex: 'dateRange',
                            valueType: 'dateTimeRange',
                            initialValue: [
                              dayjs(new Date().setHours(0, 0, 0, 0)),
                              dayjs(new Date().setHours(23, 59, 59, 999)),
                            ],
                          },
                          {
                            title: 'Output to console',
                            dataIndex: 'console',
                            valueType: 'switch',
                          },
                        ]}
                        onFinish={async (values: any) => {
                          const params = {
                            batches: values.batches?.split(','),
                            key: values.key,
                            keyword: values.keyword,
                            startDate: values.dateRange?.[0]
                              ? new Date(values.dateRange?.[0])
                              : undefined,
                            endDate: values.dateRange?.[1]
                              ? new Date(values.dateRange?.[1])
                              : undefined,
                          };

                          if (values.console) {
                            const logs = await logService.getLogs(params);
                            console.log(logs);
                          } else {
                            await exportLogs(params);
                          }
                        }}
                      ></BetaSchemaForm>
                    }
                  >
                    <Button size="small">Export Logs</Button>
                  </Popover>
                  <Button
                    size="small"
                    onClick={async () => {
                      const user = await userApis.getUser();
                      console.log('user:', user);
                      await navigator.clipboard.writeText(
                        `await apiMap.login(${JSON.stringify(user)});location.href = "http://localhost:7465/";`
                      );
                    }}
                  >
                    Copy Token
                  </Button>
                </li>
                <li>
                  <span>
                    Encrypt Msg:{' '}
                    <Switch
                      value={encryptMsg}
                      onChange={(value) => {
                        setEncryptMsg(value);
                      }}
                    ></Switch>
                  </span>
                </li>
              </ul>
            }
          >
            <span>
              <b>{info.version}</b>
              {' ['}
              {info.buildTime}
              {']'}
            </span>
          </Popover>
          <Modal></Modal>
        </div>
      )}
    </>
  );
};
export default MyCompany;
